import { Box, Typography, Button, Theme } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import { IUserPrivacy } from "./useReportLayout";
import { TagName } from "components/TagName";
import { useNavigate } from "react-router-dom";
import { urlPaths } from "enums/urlPaths";

interface IPrivacyBannerProps {
    privacyData: IUserPrivacy;
    setShouldShowBanner: React.Dispatch<React.SetStateAction<boolean>>;
}
const PrivacyBanner = ({ privacyData, setShouldShowBanner }: IPrivacyBannerProps) => {
    const navigate = useNavigate();

    const handleCloseBanner = () => {
        setShouldShowBanner(false);
    };

    return (
        <Box
            sx={(theme: Theme) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: theme.spacing(2),
                backgroundColor: theme.palette.info.main,
                color: theme.palette.common.white,
            })}
        >
            <Box display="flex" alignItems="center">
                <CustomIcon icon={icons.paceIconNotShared} sx={{ fontSize: 22, marginRight: 1 }} />
                {!privacyData.isSharingPace && (
                    <Typography variant="subtitle1">
                        You are currently not sharing your PACE profile. Click the button to adjust your settings.
                    </Typography>
                )}

                {privacyData.hubsNotSharing === 1 && (
                    <>
                        <Typography variant="subtitle1" mr={1}>
                            You are currently not sharing your PACE profile with
                        </Typography>
                        <TagName color="secondary">{privacyData.singleHubName}</TagName>
                    </>
                )}

                {privacyData.hubsNotSharing >= 2 && (
                    <Typography variant="subtitle1">
                        {`You are currently not sharing your PACE profile with ${privacyData.hubsNotSharing}/${privacyData.totalUserHubs} of your hubs.`}
                    </Typography>
                )}
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    startIcon={<CustomIcon icon={icons.share} />}
                    onClick={() => navigate(urlPaths.AccountPrivacy)}
                >
                    Share Your Profile
                </Button>
                {privacyData.isSharingPace && privacyData.hubsNotSharing !== 0 && (
                    <Button
                        variant="text"
                        size="small"
                        color="secondary"
                        onClick={handleCloseBanner}
                        sx={{
                            "& .MuiButton-startIcon": {
                                marginRight: 0,
                                marginTop: 1.2,
                            },
                        }}
                        startIcon={<CustomIcon icon={icons.closeOutlined} sx={{ fontSize: "26px !important" }} />}
                    >
                        Close
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default PrivacyBanner;
